module.exports = __webpack_public_path__ + "img/TraficLightGold.323b6559.svg";